import { render, staticRenderFns } from "./PointWindow.vue?vue&type=template&id=0713676c&scoped=true&"
import script from "./PointWindow.vue?vue&type=script&lang=js&"
export * from "./PointWindow.vue?vue&type=script&lang=js&"
import style0 from "./PointWindow.vue?vue&type=style&index=0&id=0713676c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713676c",
  null
  
)

export default component.exports